import { render, staticRenderFns } from "./LoginPorTokenView.vue?vue&type=template&id=2a0d352f"
import script from "./LoginPorTokenView.vue?vue&type=script&lang=js"
export * from "./LoginPorTokenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports